export default {
    data: ()=> {
        return {
            ruleRequired: [
                v => !!v || 'Campo obligatorio'
            ],
            ruleRequiredWith0: [
                v =>{
                    if(v === 0) return true;
                    else{
                        if(!v){
                            return 'Campo obligatorio'
                        }
                        if(v < 0){
                            return 'El valor debe ser 0 o superior'
                        }
                        return true
                    }
                } 
            ],
            ruleLegal: [
                v => !!v || 'Por favor, acepta las condiciones del servicio'
            ],
            ruleMin: [
                v => {
                    return v && v.length >= 3 || 'Debe tener al menos 3 caracteres'
                },
            ],
            ruleSlug: [
                v => {
                    if(v && v.length > 0){
                        // eslint-disable-next-line no-useless-escape
                        let regx = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;
                        return regx.test(v) || 'Formato url icorrecto';
                    }else{
                        return true;
                    }
                }
            ],
            rulePhone: [
                v => {
                    if(v && v.length > 0){
                        // eslint-disable-next-line no-useless-escape
                        let regx = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;
                        return regx.test(v) || 'Formato de teléfono incorrecto';
                    }else{
                        return true;
                    }
                }
            ],
            ruleEmail: [
                v => {
                    if(v && v.length > 0){
                        // eslint-disable-next-line no-useless-escape
                        let regx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return regx.test(v) || 'Formato de email incorrecto';
                    }else{
                        return true;
                    }
                }
            ],
            ruleMin10000: [
                v => {
                    return v && (v.length >= 5 || v >= 10000) || 'El monto debe ser superior a 10000'
                },
            ],
            ruleMin0: [
                v => {
                    return v && (v.length >= 0 || v >= 0) || 'El monto debe ser superior a cero'
                },
            ],
            ruleMax100M: [
                v => {
                    return v && (v.length <= 10 || v <= 100000000) || 'El monto debe ser inferior a 100.000.000'
                },
            ],            
            ruleNumber: [
                v => {
                    return v && !isNaN(v)  || 'Solo numeros'
                },
            ],
        }
    }
};